/** Extensões tratadas como imagem para preview de anexos/evidências. */
const IMAGE_EXTENSIONS = new Set([
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'bmp',
  'svg'
]);

/**
 * Detecta se um anexo deve exibir preview de imagem
 * (content-type, tipo lógico ou extensão do nome/URL).
 */
export function isAttachmentImage(input: {
  fileName?: string | null;
  blobUrl?: string | null;
  downloadUrl?: string | null;
  contentType?: string | null;
  tipo?: string | null;
}): boolean {
  const tipo = String(input.tipo ?? '').trim().toLowerCase();
  if (tipo === 'foto' || tipo === 'image' || tipo === 'imagem') {
    return true;
  }

  const contentType = String(input.contentType ?? '').trim().toLowerCase();
  if (contentType.startsWith('image/')) {
    return true;
  }

  const nameOrUrl = String(input.fileName || input.downloadUrl || input.blobUrl || '')
    .trim()
    .toLowerCase()
    .split('?')[0]
    .split('#')[0];
  const ext = nameOrUrl.includes('.') ? nameOrUrl.split('.').pop() || '' : '';
  return IMAGE_EXTENSIONS.has(ext);
}
